import { Link } from "react-router-dom";
import { fmtPrice } from "../lib/api";
import { useBusiness } from "../context/BusinessContext";

export default function ProductCard({ product }) {
  const { business } = useBusiness();
  const out = product.stock <= 0;
  const low = product.stock > 0 && product.stock <= 5;

  return (
    <Link
      to={`/product/${product.id}`}
      className="group block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="product-img relative">
        {product.image_url ? (
          <img src={product.image_url} alt={product.name} loading="lazy" />
        ) : (
          <div className="w-full h-full bg-neutral-200" />
        )}
        <div className="absolute top-3 left-3 flex gap-2">
          {out && (
            <span className="bg-neutral-200 text-neutral-500 px-2 py-1 text-[10px] uppercase tracking-widest line-through">
              Sold out
            </span>
          )}
          {!out && low && (
            <span className="bg-accent text-white px-2 py-1 text-[10px] uppercase tracking-widest">
              Low stock
            </span>
          )}
          {product.featured && !out && (
            <span className="bg-black text-white px-2 py-1 text-[10px] uppercase tracking-widest">
              Featured
            </span>
          )}
        </div>
      </div>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-ultra text-neutral-500">
            {product.category_name}
          </div>
          <div className="mt-1 text-sm font-medium truncate">{product.name}</div>
        </div>
        <div className="text-sm font-medium whitespace-nowrap">
          {fmtPrice(product.price, business.currency)}
        </div>
      </div>
    </Link>
  );
}
